import React from "react";
import  "./apploading.module.css";
import { Alert, AlertType, CactusLoader } from "@alku/ui-kit";

type LoadingScreenProps = {
  error: string | null;
};

const isHomePageOrNoUserRole = (): boolean => {
  return window.location.pathname === "/" || !localStorage.getItem("userRole");
};

const LoadingScreen: React.FC<LoadingScreenProps> = ({ error }) => {
  if (isHomePageOrNoUserRole()) {
    return (
      <>
        <div className="loader-container">
          <CactusLoader size="lg" />
          {error && (
            <div className="error-container">
              <Alert type={AlertType.Error} id="signup-error">
                {error}
              </Alert>
            </div>
          )}
        </div>
      </>
    );
  }

  // Return null or other fallback for non-home pages
  return null;
};

export default LoadingScreen;
